var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-1"},[_c('div',{staticClass:"w-full border-gray-300 border-b absolute left-0 right-0"})])}]

export { render, staticRenderFns }